import { useQuery } from '@apollo/client/react/hooks/useQuery'
import { Button } from '@factorialco/deprecated-design-system'
import { ExternalUsersExternalsPageQueryDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'
import accesses from 'modules/core/store/collections/users'

import Form from './Form'
// Hooks
import useForm from './useForm'
import useSubmit from './useSubmit'

interface Props {
  userId?: number
  onClose: () => void
}

const EditUserModal = ({ onClose, userId }: Props) => {
  const user = userId ? accesses.get(userId) : undefined
  const form = useForm({
    user,
  })

  // FIXME: Make editing these accesses a GQL mutation so we don't need to refetch
  const { refetch } = useQuery(ExternalUsersExternalsPageQueryDocument)

  const { submitting, onSubmit } = useSubmit({
    form,
    user,
    refetch,
  })

  const title = user
    ? i18n.t('settings.users.edit_modal.title')
    : i18n.t('settings.users.add_modal.title')

  const description = user
    ? i18n.t('settings.users.edit_modal.description')
    : i18n.t('settings.users.add_modal.description')

  const illustration = user ? 'pencil' : 'add-user'
  const email = form.get('email').value

  const isDisabled =
    !email ||
    !!accesses.find({
      email,
    })

  return (
    <Modal
      title={title}
      description={description}
      illustration={illustration}
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <Button disabled={(isDisabled || submitting) && !form.isDirty} submit>
          {i18n.t('common.save')}
        </Button>
      }
    >
      <Form form={form} />
    </Modal>
  )
}

export default observer(EditUserModal)
